import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  statusFormatter,
  infoFormatterIntl,
  infoFormatter, formatRegistryNumber,
} from '../../../utils/formatters';
import {
  responseLogWithNotification, useUpdatePeriod,
} from '../../../utils/utils';
import ApplicationHistory from './ApplicationHistory';
import ApplicationLegend from './ApplicationLegend';
import {
  APPLICATION_STATUS,
  PROCEDURE_CARRIER_TYPES,
  PROCEDURE_SZLT_TYPES,
  PROCEDURE_TYPE,
  PROCEDURE_VEHICLE_TYPES, REGISTRY_TYPE,
  USER_TYPE,
} from '../../../configs';
import { getApplicationData } from '../reducer';
import ApplicationInfoView from './ViewBlocks/ApplicationInfoView';
import ApplicantView from './ViewBlocks/ApplicantView';
import RepresentativeView from './ViewBlocks/RepresentativeView';
import ApplicationCarrierView from './ViewBlocks/ApplicationCarrierView';
import ApplicationSzltView from './ViewBlocks/ApplicationSzltView';
import ApplicationVehicleView from './ViewBlocks/ApplicationVehicleView';
import { loadSmevCheckList } from '../actions';
import { errorNotification } from '../../Notifications/notificationDecorator';
import DocumentList from './DocumentList';
import FileView from '../../../components/fields/FileInput/FileView';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import { NewValueView } from './ViewBlocks/NewValueView';
import MobileSmevDialog from './MobileSmevDialog';
import Switches from '../../../components/fields/Switches/Switches';
import ReorganizationJuridicalView from './ViewBlocks/NewValue/ReorganizationJuridicalView';
import ServiceMarkView from './ViewBlocks/NewValue/ServiceMarkView';
import FIOView from './ViewBlocks/NewValue/FIOView';
import AddressView from './ViewBlocks/NewValue/AddressView';
import OgrnView from './ViewBlocks/NewValue/OgrnView';
import OgrnipView from './ViewBlocks/NewValue/OgrnipView';
import DriverLicenseView from './ViewBlocks/NewValue/DriverLicenseView';
import VehicleRegistryBasisView from './ViewBlocks/NewValue/VehicleRegistryBasisView';
import VehicleCertificateView from './ViewBlocks/NewValue/VehicleCertificateView';
import ContractView from './ViewBlocks/NewValue/ContractView';
import SPBView from './ViewBlocks/NewValue/SPBView';
import NewSZLTView from './ViewBlocks/NewValue/NewSZLTView';
import ApplicationCarrierSzltView from './ViewBlocks/ApplicationCarrierSzltView';

export default function MobileApplicationView(props) {
  const [fullscreen, setFullscreen] = useState(false);
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    onClose = () => {},
    loadApplication = () => {},
    loadData = () => {},
  } = props;
  const {
    currentApplication = { applicant: {} },
    loadingSmevCheckList = false,
    loadingAcceptApplication,
    loadingReturnApplication,
    loadingDeniedApplication,
    loadingSuspendedApplication,
    loadingAnnulmentApplication,
    loadingSmevCheckApplication,
    loadingCurrentApplication,
    loadingReviewApplication,
    fieldsValidation,
    loadingFieldsValidation,
  } = useSelector(getApplicationData);

  const {
    applicant = {},
    representative,
    procedure,
    application_order_service,
    application_carrier = {},
    application_vehicle,
    files = [],
    documents = [],
    rejection_reasons,
    numbers = [],
    rejection_reason_messages,
    registry_subjects = [],
    registry_subject = [],
    registry_subject_type = '',
  } = currentApplication;

  let registryType = REGISTRY_TYPE.CARRIER;
  if (registry_subject_type === 'vehicle') {
    registryType = REGISTRY_TYPE.VEHICLE;
  }
  if (registry_subject_type === 'order_service') {
    registryType = REGISTRY_TYPE.ORDER_SERVICE;
  }

  const errorsProcedure = fieldsValidation?.errors?.procedure;

  useEffect(() => {
    if (errorsProcedure && Array.isArray(errorsProcedure) && errorsProcedure.length > 0) {
      errorNotification('Ошибка валидации', errorsProcedure.join(','));
    }
  }, [errorsProcedure]);

  const loadSmev = () => dispatch(loadSmevCheckList(currentApplication.id)).catch(responseLogWithNotification);
  const [setPeriod, destroy, clear, load, createTimer] = useUpdatePeriod(() => {
    loadApplication(currentApplication.id); loadSmev();
  }, 30, true);

  useEffect(() => {
    loadApplication(currentApplication?.id);
    createTimer();
    loadSmev();
    return destroy;
  }, []);

  const isVehicle = PROCEDURE_VEHICLE_TYPES.includes(procedure);
  const isSzlt = PROCEDURE_SZLT_TYPES.includes(procedure);
  const isCarrier = PROCEDURE_CARRIER_TYPES.includes(procedure);

  return ReactDOM.createPortal(
    <div className="application-form">
      <TimerLoader loading={loadingSmevCheckList || loadingAcceptApplication || loadingReturnApplication || loadingDeniedApplication || loadingSuspendedApplication || loadingAnnulmentApplication || loadingSmevCheckApplication || loadingCurrentApplication || loadingReviewApplication || loadingFieldsValidation} />
      <div className="mobile-application-form">
        <div className="mobile-header">
          <div className="application-number">
            <div className="application-text">Обращение № {currentApplication.mais_egu_id || 'Без номера'}</div>
            <div className="legend-button">
              <Icons width={24} height={24} customIcon icon="helper" className="legend-icon" />
              <ApplicationLegend />
            </div>
          </div>
          <div className="application-status-block">
            {currentApplication.status ? statusFormatter(currentApplication.status) : null}
            <NavLink className="history-link" to={`/application/history?subject_id=${currentApplication.id}`} target="_blank" title="История изменений">
              <Icons
                customIcon
                className="history-icon"
                icon="history-relation"
              />
            </NavLink>
            <NavLink className="show-relation-link" to={`/application/mais-history?maisEguNumber=${currentApplication?.mais_egu_id}&procedure=${procedure}`} target="_blank" title="История изменений">
              <Icons
                customIcon
                className="history-icon"
                icon="show-relation-link"
              />
            </NavLink>
            {showHistoryDialog ? (
              <ApplicationHistory
                currentApplication={currentApplication}
                close={() => setShowHistoryDialog(false)}
              />
            ) : null}
          </div>
        </div>
        <div className="smev-info-block">
          <div className="smev-info-title f4">
            Перечень запросов СМЭВ/СМЭВ СПб
          </div>
          <div className="smev-info-button" onClick={() => setFullscreen(!fullscreen)}>
            <Icons
              customIcon
              icon={fullscreen ? 'full-screen-close' : 'full-screen'}
            />
          </div>
          {fullscreen ? (
            <MobileSmevDialog
              currentApplication={currentApplication}
              handleClose={() => setFullscreen(false)}
              loadApplication={loadApplication}
              loadData={loadData}
            />
          ) : null}
        </div>
        <div className="mobile-application-data custom-scroll-theme">
          <AccordionWithPreview
            title="Информация об обращении"
            component={ApplicationInfoView}
            componentProps={{
              fieldsValidation,
              currentApplication,
            }}
          />
          <AccordionWithPreview
            title="Получатель услуги"
            component={ApplicantView}
            componentProps={{
              fieldsValidation,
              className: 'mt-3',
              applicant,
              currentApplication,
            }}
          />
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => {},
                  value: representative,
                }}
                label="Представитель"
              />
            </Col>
          </Row>
          {representative ? (
            <AccordionWithPreview
              title="Представитель"
              component={RepresentativeView}
              componentProps={{
                fieldsValidation,
                representative,
                currentApplication,
              }}
            />
          ) : null}
          {isCarrier ? (
            <ApplicationCarrierView
              key="application-carrier-view"
              fieldsValidation={fieldsValidation}
              currentApplication={currentApplication}
              data={application_carrier || {}}
            />
          ) : null}
          {isSzlt ? (
            <ApplicationSzltView
              fieldsValidation={fieldsValidation}
              currentApplication={currentApplication}
              data={application_order_service || {}}
            />
          ) : null}
          {isVehicle ? (
            <ApplicationVehicleView
              fieldsValidation={fieldsValidation}
              currentApplication={currentApplication}
              data={application_vehicle || {}}
            />
          ) : null}
          <ReorganizationJuridicalView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <ServiceMarkView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <FIOView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <AddressView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <OgrnView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <OgrnipView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <DriverLicenseView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <VehicleRegistryBasisView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <VehicleCertificateView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <ContractView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <SPBView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          <NewSZLTView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
          {isCarrier ? (
            <ApplicationCarrierSzltView
              key="application-carrier-view"
              fieldsValidation={fieldsValidation}
              currentApplication={currentApplication}
              data={application_carrier || {}}
            />
          ) : null}
          <FileView files={files} />
          <AccordionWithPreview
            title="Итоговое решение"
            content={(
              <DocumentList
                documents={documents}
                id={currentApplication?.id}
                loadData={() => {
                  loadApplication();
                  loadData();
                }}
              />
              )}
          />
          {numbers?.length && [PROCEDURE_TYPE.PROCEDURE_1227_1, PROCEDURE_TYPE.PROCEDURE_1227_6, PROCEDURE_TYPE.PROCEDURE_1228_1].includes(procedure) ? (
            <div>
              <div className="f4 mt-3">Результаты рассмотрения обращения</div>
              <div className="mt-3">
                {formatRegistryNumber(numbers, registry_subjects, registry_subject, registryType, null, 'carrier')}
              </div>
            </div>
          ) : null}
          <Row className="row-cols-1">
            {infoFormatterIntl('application.comment', currentApplication?.comment)}
          </Row>
          {rejection_reasons && [APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.RETURN, APPLICATION_STATUS.DENIED].includes(currentApplication.status) ? (
            <>
              <div className="f4 mt-3">{formatMessage({ id: `rejection.reason.header.${currentApplication.status}`, defaultMessage: 'Причины статуса' })}</div>
              <Row className="row-cols-1">
                {infoFormatter('Основания', rejection_reason_messages?.map(e => e.name).join(', ') || '')}
              </Row>
              <Row className="row-cols-1">
                {infoFormatter('Дополнительное основание', rejection_reason_messages?.[0]?.additional_message || '')}
              </Row>
              <Row className="row-cols-1">
                {infoFormatter('Комментарий', rejection_reason_messages?.[0]?.message || '')}
              </Row>
            </>
          ) : null}
        </div>
        <div className="mobile-application-footer">
          <Button variant="secondary" onClick={onClose}>Закрыть</Button>
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
